import { useQuery } from '@tanstack/react-query';
import type { AxiosRequestConfig } from 'axios';
import type { Language } from '@tsTypes/api/Language';
import type { HydraCollection } from 'types/HydraCollection';
import { ENDPOINT } from '@constants/endpoint';
import axios from '@utils/axiosInstance';

const STALE_TIME_MS = 1000 * 60 * 30;

export const getLanguages = async (config?: AxiosRequestConfig) => {
  const { data } = await axios.get<HydraCollection<Language>>(
    ENDPOINT.LANGUAGES,
    {
      withToken: false,
      ...config,
    }
  );

  return data['hydra:member'];
};

const useLanguages = (options: { enabled: boolean }) =>
  useQuery({
    queryKey: ['languages'],
    queryFn: () => getLanguages(),
    staleTime: STALE_TIME_MS,
    ...options,
  });

export default useLanguages;
